define('app/controllers/arrendataris',['angular', 'app/services/shared'], function(angular) {
  var module = angular.module('app.arrendataris', ['app.shared']);

  module.controller('ArrendatariEditController', [
    '$scope',
    '$http',
    '$route',
    '$location',
    '$filter',
    'sharedProperties',
    '$mdEditDialog',
    '$mdDialog',
    'actionFactory',
    'consumer',
    'state',
    'info',
    'elem',
    'elems',
	'extrainfo',
    function($scope, $http, $route, $location, $filter, sharedProperties, $mdEditDialog, $mdDialog, actionFactory, consumer, state, info, elem, elems, extrainfo) {

      var isNew = state.state.editing == false && state.state.viewing == false
      $scope.actions = state.elemActions;
      $scope.state = state.state;
      $scope.elems = elems;
	  $scope.extrainfo = extrainfo;

      if (isNew) {
        $scope.elemId = 0;
        $scope.elem = {};
        $scope.elem.AltresConceptes = [];
      } else {
        $scope.elemId = info.isInt ? parseInt($route.current.params.id):$route.current.params.id;
        $scope.elem = elem;
        elem.AltresConceptes = elem.AltresConceptes || [];
        actionFactory.complementActions(info, $scope.actions, $scope.elemId);
      }

      $scope.lpactions = [{"id": "delete","active": true,"visible": true,"global": false,"name": "Eliminar","icon": "content:ic_delete_sweep_24px","action": "DeleteConcepte"}];
      $scope.query = {order:"Concepte"};
      $scope.columns = [
        { active: true, name: "Concepte", title: "Concepte", isnum: false, orderBy: "Concepte"},
        { active: true, name: "Import", title: "Import", isnum: true, orderBy: "Import" }
      ];

      var rebuts = info.allData["rebuts"];
      $scope.actionsRebuts = rebuts.states.browse.elemActions;
      $scope.rebuts = rebuts;
      $scope.queryRebuts = {order:"Order"};

      if (!isNew) {
        var theIds = [];
        angular.forEach(elems.rebuts.Results, function (value, key) {
          this.push(value.Id);
        }, theIds);
        actionFactory.complementActions(rebuts, $scope.actionsRebuts, theIds);
      }

      $scope.editCarreg = function(carrec) {
        var CarregDlgController = ['$scope', '$mdDialog', function ($scope, $mdDialog) {

          $scope.rebut = carrec;
          $scope.hide = function () {
            $mdDialog.hide()
          };
          $scope.cancel = function () {
            $mdDialog.cancel()
          };
          $scope.ok = function (value) {
            $mdDialog.hide(value)
          }
        }];

        $mdDialog.show({
          controller: CarregDlgController,
          templateUrl: 'templates/editConcepte.html',
          parent: angular.element(document.body),
          // targetEvent: event,
          clickOutsideToClose: true,
          fullscreen: false
        }).then(function (pagament) {

        }, function () {

        });
      };

      $scope.$on('naction', function (event, action, id) {
        $scope.error = false;

        if (action.name === 'AddConcepte') {
          var carrec = {};
          $scope.elem.AltresConceptes.push(carrec);
          $scope.editCarreg(carrec);
          return;
        }
        else if (action.name === 'EditConcepte') {
          $scope.editCarreg(action.row);
          return;
        }
        else if (action.name === 'DeleteConcepte') {
          var confirm = $mdDialog.confirm()
            .title('Segur que vols eliminar aquest concepte?')
            .textContent('Si et rajas, no guardis els canvis d\'aquest arrendatari! ;-)')
            .ariaLabel('Bona sort!')
            //.targetEvent(event)
            .ok('Si, fes-ho!')
            .cancel('Potser millor deixar-ho!');
          $mdDialog.show(confirm).then(function() {
            var index = $scope.elem.AltresConceptes.indexOf(action.row);
            $scope.elem.AltresConceptes.splice(index, 1);
          });
          return;
        }

        var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params);
        promise.then(function (retVal) {
          console.log(retVal);
          if (retVal.processed && retVal.refresh && retVal.elem) {
            $scope.elem = retVal.elem;
            actionFactory.updateItemActions(info, state.elemActions, id);
          }
        }, function (reason) {
          $scope.error = true;
          $scope.errorMessage = sharedProperties.getErrorMessage(reason);
          console.log('Failed', reason)
        }, function (update) {
          console.log('Got notification', update)
        })
      })

    }
  ]);


  return module;
});
